import { useEffect, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import classNames from 'classnames';

import { LiveLocationIcon, TooltipButton, TooltipPlacement } from '@jsmdg/yoshi';
import { storageAvailable } from '../../../../../helper/storageHelper';
import { SearchReducerActionType } from '../../../../../reducers/searchReducer';
import styles from './CurrentLocationButton.module.scss';

type CurrentLocationButtonProps = {
    readonly onSubmit: (type: SearchReducerActionType) => void;
    readonly location?: string;
};

const messages = defineMessages({
    currentLocation: {
        defaultMessage: 'Dein Standort',
    },
    a11yCloseButton: {
        defaultMessage: 'Tooltip schließen',
    },
});

const CurrentLocationButton = ({
    location = '',
    onSubmit,
}: CurrentLocationButtonProps): JSX.Element | null => {
    const intl = useIntl();
    const [locationDenied, setLocationDenied] = useState(false);

    useEffect(() => {
        if (storageAvailable('sessionStorage')) {
            setLocationDenied(window.sessionStorage.getItem('locationApiAccepted') === 'false');
        }
    }, []);

    const getCurrentLocation = (): void => {
        onSubmit(SearchReducerActionType.GeoCoordinates);
    };

    if (location || locationDenied) {
        return null;
    }

    return (
        <TooltipButton
            onClick={getCurrentLocation}
            className={classNames('d-flex h-100 w-100 align-items-center justify-content-center')}
            tooltipPlacement={TooltipPlacement.Top}
            tooltip={intl.formatMessage(messages.currentLocation)}
            data-testid="locate-me-button"
            a11yLabel={intl.formatMessage(messages.currentLocation)}
            a11yCloseButton={intl.formatMessage(messages.a11yCloseButton)}
        >
            <span
                className={classNames(
                    'd-xs-flex align-items-center justify-content-center pt-0-5x pt-xs-0 pl-1x',
                    styles.button,
                )}
            >
                <LiveLocationIcon ariaHidden className={styles.icon} />
            </span>
        </TooltipButton>
    );
};

export { CurrentLocationButton };
